import { getFeature } from 'Cloud/Application/FeaturesEs6';

/**
 * alpha-team
 * CLOUDWEB-18017: Последние файлы. Убрать блок последние файлы под фичу
 */
export const lastFilesWidgetHidden: boolean = getFeature('hide-last-files-widget') ?? false;
